import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useSaveFileInBrowser } from '../../../common/hooks/useSaveFileInBrowser';

export const AttachmentPreviewLink = (props: {
  attachmentId: string;
  attachmentName: string;
  tooltipText?: string;
}) => {
  const saveFileInBrowser = useSaveFileInBrowser();

  const handlePreview = () => {
    void saveFileInBrowser(props.attachmentId, props.attachmentName, 'open');
  };

  const handleDownload = () => {
    void saveFileInBrowser(
      props.attachmentId,
      props.attachmentName,
      'download',
    );
  };

  return (
    <>
      <OverlayTrigger
        overlay={<Tooltip>{props.tooltipText ?? 'Podgląd'}</Tooltip>}
      >
        <Button
          onClick={e => {
            e.stopPropagation();
            handlePreview();
          }}
          variant="btn-info"
          className="me-1"
        >
          <Icon.Eye />
        </Button>
      </OverlayTrigger>
      <OverlayTrigger overlay={<Tooltip>Pobierz</Tooltip>}>
        <Button
          onClick={e => {
            e.stopPropagation();
            handleDownload();
          }}
          variant="btn-success"
        >
          <Icon.Download />
        </Button>
      </OverlayTrigger>
    </>
  );
};
